/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
import { PureComponent } from 'react';

import MyAccountQuery from 'Query/MyAccount.query';
import browserHistory from 'Util/History';
import { fetchQuery } from 'Util/Request/Query';
import getStore from 'Util/Store';

import SubscriptionPreferencesComponent from './SubscriptionPreferences.component';

/** @namespace Scandipwa/Route/SubscriptionPreferences/Container */
export class SubscriptionPreferencesContainer extends PureComponent {
    state = {
        iframeLoading: true,
        iframeUrl: ''
    };

    containerFunctions = {
        closePreferences: this.closePreferences.bind(this)
    };

    // eslint-disable-next-line react/sort-comp
    closePreferences() {
        browserHistory.go(-1);
    }

    componentDidMount() {
        const store = getStore();
        const { MyAccountReducer: { customer: { email } = {} } } = store.getState();

        if (!email) {
            return;
        }

        const query = MyAccountQuery.getEmarsysPreferencesLink(email);

        fetchQuery(query).then(
            /** @namespace Scandipwa/Route/SubscriptionPreferences/Container/SubscriptionPreferencesContainer/componentDidMount/fetchQuery/then */
            ({ EmarsysGetPreferences: iframeUrl }) => {
                this.setState({ iframeUrl, iframeLoading: false });
            }
        );
    }

    render() {
        return (
            <SubscriptionPreferencesComponent
              { ...this.state }
              { ...this.containerFunctions }
            />
        );
    }
}

export default SubscriptionPreferencesContainer;
